import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

interface InterpolationToggleGroupProps {
  value: 'spline' | 'linear' | 'vhv' | 'hvh' | 'vh' | 'hv';
  onChange: (value: 'spline' | 'linear' | 'vhv' | 'hvh' | 'vh' | 'hv') => void;
}

export const InterpolationToggleGroup: React.FC<
  InterpolationToggleGroupProps
> = ({ value, onChange }) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, value) =>
        onChange(value as 'spline' | 'linear' | 'vhv' | 'hvh' | 'vh' | 'hv')
      }
      size="small"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: 0.5,
        '& .MuiToggleButton-root': {
          px: 0.75,
          py: 0.25,
          minHeight: 24,
          fontSize: '0.7rem',
          lineHeight: 1.1,
        },
      }}
    >
      <ToggleButton value="spline">Spline</ToggleButton>
      <ToggleButton value="linear">Lineaire</ToggleButton>
      <ToggleButton value="vhv">VH-V</ToggleButton>
      <ToggleButton value="hvh">HV-H</ToggleButton>
      <ToggleButton value="vh">VH</ToggleButton>
      <ToggleButton value="hv">HV</ToggleButton>
    </ToggleButtonGroup>
  );
};
